/**
 * What the profit and loss export is saved as when the server's own name did
 * not arrive.
 *
 * ## Everything else about the download is `cash-book-export.ts`, deliberately
 *
 * FE050 built the mechanism and this module uses it unchanged:
 * `saveDownloadedFile` there turns bytes already in hand into a saved file, and
 * `ApiClient.download` is what fetched them with the credential attached. Both
 * notes are worth reading before touching either — in short, an anchor pointed
 * at `/v1/reports/profit-and-loss.csv` **cannot work**, because the route reads
 * its principal from `Authorization: Bearer` and from nowhere else, so a plain
 * navigation saves a `401` envelope with `.csv` on the end and nothing about it
 * looks wrong until somebody opens it.
 *
 * That argument is sharper here than it was there. This export is
 * `@RequireRole('OWNER')` and carries what the goods cost and the margin on
 * them — the export the split in `export.controller.ts` exists for. A file that
 * is quietly a refusal envelope is bad; a *financial* file that is quietly a
 * refusal envelope, filed and read back a quarter later, is worse. The API says
 * this on the `200` itself now, which is where the next person adding an export
 * will actually be looking.
 *
 * ## Why there is no longer a period in this name
 *
 * This module used to rebuild the server's own filename from the period, because
 * `Content-Disposition` is not CORS-safelisted and the API exposed only
 * `x-request-id`. Their #406 exposed it, so the name the server chose is read
 * off the response and used, and the mirror is gone — it was a copy of a rule in
 * another repository, and a copy that goes stale silently.
 *
 * What is left is a default for the case where the header did not arrive at all,
 * which a proxy in front of the API can still cause. It names the report and
 * carries no period, so it cannot pretend to be the server's name and cannot
 * drift away from it either.
 */

/**
 * `profit-and-loss`, not `cash-book`: the two exports are saved side by side in
 * the same folder, and if a proxy strips the header from both, an owner still
 * has to be able to tell them apart without opening either.
 */
export const PROFIT_AND_LOSS_DEFAULT_FILENAME = 'profit-and-loss.csv';
